import {Injectable} from '@angular/core';
import {Http, RequestOptions, URLSearchParams, Headers, ResponseContentType} from '@angular/http';
import 'rxjs/add/operator/map';

import {SettingsProvider} from '../settings';
import {LoaderProvider} from "../loader";
import {AlertService} from '../util/alert.service';
import {Events, NavController} from "ionic-angular";
import {ConstantProvider} from "../constants";

@Injectable()
export class ApiProvider {

    url: string
    token: string = '';

    constructor(public http: Http,
                public settings: SettingsProvider,
                public events: Events,
                public loader: LoaderProvider,
                public alert: AlertService, public constants: ConstantProvider) {

        this.url = this.constants.API_URL;

    }

    obter(endpoint: string, params?: any, options?: RequestOptions) {
        return new Promise((resolve, reject) => {
            this.pget(endpoint, params, options).then((res: any) => {
                if (res != undefined) {
                    if (res.data) {
                        resolve(res.data)
                    } else {
                        resolve(res)
                    }
                }
            }, (err: any) => {
                if (err != undefined) {
                    if (err.data) {
                        reject(err.json())
                    } else {
                        reject(err)
                    }
                }
            });

        });
    }

    pget(endpoint: string, params?: any, options?: RequestOptions) {
        return new Promise((resolve, reject) => {
            this.settings.loadSetting('session')
                .then(res => {
                    if (!options) {
                        options = new RequestOptions();
                    }
                    if (res == undefined) {
                        return [];
                    }
                    options.headers = new Headers();
                    options.headers.append('Authorization', 'Bearer ' + res.access_token);
                    if (params) {
                        let p = new URLSearchParams();
                        for (let k in params) {
                            p.set(k, params[k]);
                        }
                        options.search = !options.search && p || options.search;
                    }
                    return this.http
                        .get(this.url + '/' + endpoint, options)
                        .subscribe(
                            (res: any) => {
                                let resp = res.json();
                                if(resp.logout) {
                                    this.events.publish('reload:fnLogout');
                                } else {
                                    resolve(res.json())
                                }
                            },
                            (error: any) => {
                                this.loader.hide();
                                this.MessageErroRequest(error);
                            }
                        );
                });
        });
    }

    post(endpoint: string, body: any, options?: RequestOptions) {
        return new Promise(resolve => {
            this.settings.loadSetting('session')
                .then(res => {
                    if (!options) {
                        options = new RequestOptions();
                    }
                    if (res == undefined) {
                        return [];
                    }
                    options.headers = new Headers();
                    options.headers.append('Authorization', 'Bearer ' + res.access_token);

                    return this.http.post(this.url + '/' + endpoint, body, options)
                        .subscribe(res => {
                                let resp = res.json();
                                if(resp.logout) {
                                    this.events.publish('reload:fnLogout');
                                } else {
                                    resolve(res.json())
                                }
                            },
                            (error: any) => {
                                this.loader.hide();
                                this.MessageErroRequest(error);
                            });
                });
        });
    }

    MessageErroRequest(objErro) {
        this.alert.presentAlert("Erro", objErro.status + " -> " + objErro.statusText);
    }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts